<template>
  <div class="container-fluid">
    <div style="display: none!important;">
      <!-- <electron-vue-printer ref="electronVuePrinter" :show="false" :options="options" :rotateType="rotateType"
        @webview-ready="Printer" :silent="true">
      </electron-vue-printer> -->
    </div>
    {{print}}
    <div id="my-node">
      <div style="padding: 0 15px;">
        <div class="text-center" v-if="print_type != ''"><b>{{ print_type }}</b></div>
        <div class="row">
          <!-- sender section -->
          <!-- <div class="col-md-5 header-style">
        <p class="text-center"><b>{{ $t("СОТУВЧИ") }}</b></p>
        <p class="text-center"><b>{{header.sender != null ? header.sender.firm_name : ''}}</b></p>
        <p class="text-center">{{header.sender != null ? header.sender.address : ''}}</p>
        <p>Р/С: {{header.sender != null ? header.sender.p_c : ''}}</p>
        <p>
          <span>МФО: {{header.sender != null ? header.sender.mfo : ''}}&ensp;</span>
          <span>ОКОНХ: {{header.sender != null ? header.sender.oked : ''}}</span>
        </p>
        <p>ИНН: {{header.sender != null ? header.sender.inn : ''}}</p>
        <p>{{header.sender != null ? header.sender.director : ''}}</p><br>
        <p>{{ $t("М.Ў.") }}</p>
      </div> -->
          <div class="col-md-12">
            <h5 style="width: 100%;">
              {{$t('Расходная накладная')+" №"+datas.daily_number+" от "+Datetime(datas.created_at)}} </h5>
            <hr class="hr">
          </div>
          <div class="col-md-3">
            {{ $t("Етказувчи") }}
          </div>
          <div class="col-md-9">
            <b>{{header.sender != null ? header.sender.firm_name : ''}}</b>
          </div>
          <div class="col-md-3">
            {{ $t("ХАРИДОР") }}
          </div>
          <div class="col-md-9">
            <p class="m-0"><b>{{kontragent != null ? kontragent.name : ''}}</b></p>
            <p class="m-0"><b>{{kontragent != null ? kontragent.address : ''}}</b></p>
            <p class="m-0"><b>{{kontragent != null ? kontragent.phone_number : ''}}</b></p>
          </div>
          <!-- <div class="col-md-2"></div> -->
          <!-- receiver section -->
          <!-- <div class="col-md-5 header-style" v-if="kontragent!=null">
        <p class="text-center"><b>{{ $t("ХАРИДОР") }}</b></p>
        <p class="text-center"><b>{{kontragent.firma != null ? kontragent.firma.name : ''}}</b></p>
        <p class="text-center">{{kontragent != null ? kontragent.address : ''}}</p>
        <p>Р/С: {{kontragent != null ? kontragent.account_number : ''}}</p>
        <p>
          <span>МФО: {{kontragent != null ? kontragent.mfo_id : ''}}&ensp;</span>
          <span>ОКОНХ: {{kontragent != null ? kontragent.okonx : ''}}</span>
        </p>
        <p>ИНН: {{kontragent != null ? kontragent.inn : ''}}</p>
        <p>{{kontragent != null ? kontragent.name : ''}}</p><br>
        <p>{{ $t("М.Ў.") }}</p>
      </div> -->
        </div>
        <!-- table section -->
        <div class="row px-4 my-4">
          <table class="table table-bordered table-sm prints"
            style="background: none!important; border-radius: 0px!important;">
            <tbody>
              <tr class="text-center">
                <td rowspan="2"><b>№</b></td>
                <td rowspan="2"><b>Товар</b></td>
                <td colspan="2"><b>{{$t('Кол.')}}</b></td>
                <td colspan="2"><b>{{ $t("Нарх") }}</b></td>
                <td rowspan="2"><b>Сумма</b></td>
              </tr>
              <tr class="text-center">
                <td>{{$t('Штук')}}</td>
                <td>Пачка</b></td>
                <td>{{$t('Штук')}}</td>
                <td>Пачка</b></td>
              </tr>
              <tr v-for="(item, index) in datas.rasxod_table" :key="index">
                <td class="text-center">{{ index + 1 }}</td>
                <td>{{ item.product != null ? (item.product.extra_name || item.product.name || "") : "" }}</td>
                <td class="kol">{{ item.count|numFormatuniversal }}</td>
                <td class="kol">{{ item.pack_count|numFormatuniversal }}</td>
                <td class="kol">{{ item.price|numFormatuniversal }}</td>
                <td class="kol">{{ item.pack_price|numFormatuniversal }}</td>

                <td class="kol">{{ item.summa|numFormatuniversal }}</td>
              </tr>
              <tr>
                <td colspan="2" class="text-center"><b>{{ $t("Жами") }}:</b></td>
                <td class="kol"><b>{{ all_count|numFormatuniversal }}</b></td>
                <td class="kol"><b></b></td>
                <td class="kol"><b></b></td>
                <td class="kol"><b></b></td>
                <td class="kol"><b>{{ all_summa|numFormatuniversal }}</b></td>
              </tr>
            </tbody>
          </table>
          <!-- <p style="width:100%; display: block">{{ $t("Етказиб берилган товарларнинг умумий қиймати:") }} {{datas.summa|numFormatuniversal}}</p> -->
          <div class="col-md-6" v-if="datas.kontragent"></div>
          <div class="col-md-3" v-if="datas.kontragent">
            {{ $t("Бошланғич сумма") }}:
          </div>
          <div class="col-md-3 end" v-if="datas.kontragent">
          <b>  {{ boshsom|numFormatuniversal }}</b>
          </div>
          <div class="col-md-6" v-if="datas.kontragent"></div>
          <div class="col-md-3" v-if="datas.kontragent">
            {{ $t("Бошланғич сумма") }} валюта:
          </div>
          <div class="col-md-3 end" v-if="datas.kontragent">
            <b>{{ boshdollar|numFormatuniversal }}</b>
          </div>
          <div class="col-md-6"></div>
          <div class="col-md-3">{{$t('Итого')}}:</div>
          <div class="col-md-3 end"><b>{{datas.summa|numFormatuniversal}}</b></div>
          <!-- <div class="col-md-6"></div> -->
          <!-- <div class="col-md-3">{{$t('Без налога (НДС)')}}:</div> -->
          <!-- <div class="col-md-3 end"></div> -->
          <!-- <div class="col-md-6"></div> -->
          <!-- <div class="col-md-3">{{$t('Отгружено на сумму')}}:</div> -->
          <!-- <div class="col-md-3 end"><b>{{datas.summa|numFormatuniversal}}</b> <b v-if="datas.pay_type_id==3">$</b><b -->
          <!-- v-else>cўм</b></div> -->
          <div class="col-md-6" v-if="datas.skidka_summa > 0"></div>
          <div class="col-md-3" v-if="datas.skidka_summa > 0">Скидка :</div>
          <div class="col-md-3 end" v-if="datas.skidka_summa > 0"><b>{{datas.skidka_summa|numFormatuniversal}}</b></div>
          <div class="col-md-6"></div>
          <div class="col-md-3">{{$t('Оплата')}} сумма:</div>
          <div class="col-md-3 end"><b>{{datas.summa-datas.skidka_summa|numFormatuniversal}}</b></div>
          <div class="col-md-6" v-if="datas.cash_summa > 0"></div>
          <div class="col-md-3" v-if="datas.cash_summa > 0">{{$t('Оплата')}} {{$t('Нахд')}}:</div>
          <div class="col-md-3 end" v-if="datas.cash_summa > 0"><b>{{datas.cash_summa|numFormatuniversal}}</b></div>
          <div class="col-md-6" v-if="datas.plastic_summa > 0"></div>
          <div class="col-md-3" v-if="datas.plastic_summa > 0">{{$t('Оплата')}} {{$t('Пластик')}}:</div>
          <div class="col-md-3 end" v-if="datas.plastic_summa > 0"><b>{{datas.plastic_summa|numFormatuniversal}}</b>
          </div>
          <div class="col-md-6" v-if="datas.dollar_summa > 0"></div>
          <div class="col-md-3" v-if="datas.dollar_summa > 0">{{$t('Оплата')}} {{$t('Валюта')}}:</div>
          <div class="col-md-3 end" v-if="datas.dollar_summa > 0"><b>{{datas.dollar_summa|numFormatuniversal}}</b></div>
          <div class="col-md-6"></div>
          <div class="col-md-3">{{$t('Қарздорлик')}} :</div>
          <div class="col-md-3 end"><b>{{qarz|numFormatuniversal}}</b></div>
          <div class="col-md-6"></div>
          <div class="col-md-3">{{$t('Қарздорлик')}} {{$t('Валюта')}} :</div>
          <div class="col-md-3 end"><b>{{qarz_dollar|numFormatuniversal}}</b></div>
          <div class="col-md-12">
            <b>{{$t('Всего наименований')+" "+all_count+", на сумму "}}{{all_summa|numFormatuniversal}}</b><b
              v-if="datas.pay_type_id==3">$</b><b v-else>cўм</b>
          </div>
        </div>
        <div class="row font-point">
          <div class="col-md-2">
            <span>{{ $t("Отпустил") }}:</span>
          </div>
          <div class="col-md-4">
            <hr class="imzo">
            <b class="imzotext">{{$t('Имзо')}}</b>
          </div>
          <div class="col-md-2">
            <span>{{ $t("Получил") }}:</span>
          </div>
          <div class="col-md-4">
            <hr class="imzo">
            <b class="imzotext">{{$t('Имзо')}}</b>
          </div>
          <div class="col-md-12" style="text-align: end;">
            <b>{{$t('М.П')}}</b>
          </div>
          <!-- <div class="col-md-5">{{header.sender != null ? header.sender.director : ''}}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from "jquery";
  import * as htmlToImage from "html-to-image";
  import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
  import electronVuePrinter from "electron-vue-printer";
  export default {
    components: { electronVuePrinter, htmlToImage },
    data() {
      return {
        header: {
          sender: null,
          receiver: null
        },
        datas: [],
        kontragent: null,
        qarz: 0,
        qarz_dollar: 0,
        mysklad: [],
        print: 'false',
        print_type: '',
        rotateType: 0,
        options: {
          // imageWidth:790,
          offsetX: 0,
          offsetY: 0
        },
        all_count: 0,
        all_price: 0,
        all_summa: 0,
      }
    },
    async updated() {
      if (this.print == 'print') {
        // this.$refs.electronVuePrinter.deviceNamePrint = this.header.printer_name;
        // await this.$refs.electronVuePrinter.print(this.dataUrl);
        var head = $("#my-node").html();
        if (head == undefined) {
          head = "";
        }
        window.document.body.innerHTML = head;
        window.print();
        window.close();
        // window.location.reload();
      }
    },
    computed: {
      boshsom() {
        var data = 0;
        if (this.datas.pay_type_id != 3) {
          data = this.qarz - (this.datas.summa - this.datas.skidka_summa - this.datas.cash_summa - this.datas.plastic_summa - this.datas.shot_summa - this.datas.dollar_summa * this.datas.dollar_rate + this.datas.refund_money + this.datas.refund_money_dollar * this.datas.dollar_rate);
        } else {
          data = this.qarz;
        }
        return data;
      },
      boshdollar() {
        var data = 0;
        if (this.datas.pay_type_id == 3) {
          data = this.qarz_dollar - (this.datas.summa - this.datas.skidka_summa - this.datas.cash_summa / this.datas.dollar_rate - this.datas.plastic_summa / this.datas.dollar_rate - this.datas.shot_summa / this.datas.dollar_rate - this.datas.dollar_summa + this.datas.refund_money / this.datas.dollar_rate + this.datas.refund_money_dollar);
        } else {
          data = this.qarz_dollar;
        }
        return data;
      },
    },
    mounted: function () {
      this.Printer();
    },
    created: function () {
      this.GetHeader();
      this.GetTable();
      if (localStorage.getItem("print_type")) {
        this.print_type = localStorage.getItem("print_type");
      }
    },
    methods: {
      data_await() {
        let self = this;
        if (self.datas.created_at) {
          self.Starprinting(true);
        } else {
          self.data_await()
        }
      },
      Convert(number) {
        var NS = [
          { value: 10000000000, str: "миллиарт" },
          { value: 10000000, str: "миллион" },
          { value: 1000, str: "тысяча" },
          { value: 100, str: "сто" },
          { value: 90, str: "девяносто" },
          { value: 80, str: "восемьдесят" },
          { value: 70, str: "семьдесят" },
          { value: 60, str: "шестьдесят" },
          { value: 50, str: "пятьдесят" },
          { value: 40, str: "сорок" },
          { value: 30, str: "тридцать" },
          { value: 20, str: "двадцать" },
          { value: 19, str: "девятнадцать" },
          { value: 18, str: "восемнадцать" },
          { value: 17, str: "семнадцать" },
          { value: 16, str: "шестнадцать" },
          { value: 15, str: "пятнадцать" },
          { value: 14, str: "четырнадцать" },
          { value: 13, str: "тринадцать" },
          { value: 12, str: "двенадцать" },
          { value: 11, str: "одиннадцать" },
          { value: 10, str: "десять" },
          { value: 9, str: "девять" },
          { value: 8, str: "восемь" },
          { value: 7, str: "семь" },
          { value: 6, str: "шесть" },
          { value: 5, str: "пять" },
          { value: 4, str: "четыре" },
          { value: 3, str: "три" },
          { value: 2, str: "два" },
          { value: 1, str: "один" }
        ];
        var result = '';
        for (var n of NS) {
          if (number >= n.value) {
            if (number <= 99) {
              result += n.str;
              number -= n.value;
              if (number > 0) result += ' ';
            } else {
              var t = Math.floor(number / n.value);
              var d = number % n.value;
              if (d > 0) {
                return this.Convert(t) + ' ' + n.str + ' ' + this.Convert(d);
              } else {
                return this.Convert(t) + ' ' + n.str;
              }

            }
          }
        }
        return result;
      },
      Datetime(date) {
        var d = new Date(date * 1000);
        var dt = d.getDate();
        var month = d.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        if (dt < 10) {
          dt = "0" + dt;
        }

        return dt + "-" + month + "-" + d.getFullYear();
      },
      Starprinting(data) {
        if (data == true) {
          setTimeout(() => {
            localStorage.removeItem("print_type");
            window.close();
          }, 1000);
        }
      },
      async Printer() {
        if (this.datas.created_at) {
          let self = this;
          // var node = document.getElementById("my-node");
          // await htmlToImage
          //   .toSvg(document.getElementById("my-node"))
          //   .then(function (dataUrl) {
          //     self.dataUrl = dataUrl;
          self.print = 'print';
          // })
          // .catch(function (error) {
          // console.error("oops, something went wrong!", error);
          // });
        } else {
          setTimeout(() => {
            this.Printer()
          }, 1000);
        }
      },
      GetHeader() {
        let self = this;
        axios({
          method: "post",
          url: "api/v1/sklad-settings",
          data: { sklad_id: localStorage.getItem('sklad_id'), key: 'a4_printer' }
        }).then(function (response) {
          if (response.data.data != null) {
            console.log(response.data);
            self.header = JSON.parse(response.data.data);
          }
        });
      },
      GetTable() {
        let self = this;
        axios({
          method: "get",
          url: "api/v1/rasxod/id/" + self.$route.params.id
        }).then(function (response) {
          self.datas = response.data;
          self.Mysklad();
          if (response.data.kontragent_id > 0) {
            self.GetKontragent(response.data.kontragent_id);
          }
          self.Qarzdorlik();
          self.Summa();
          setTimeout(() => {
            self.data_await()
          }, 3500);
        });
      },
      GetKontragent(id) {
        let self = this;
        axios({
          method: "get",
          url: "api/v1/kontragent/id/" + id
        }).then(function (response) {
          self.kontragent = response.data;
        });
      },
      Qarzdorlik() {
        let self = this;
        self.qarz = 0;
        self.qarz_dollar = 0;
        axios({
          method: "post",
          url: "api/v1/kontragent/total",
          data: {
            kontragent_id: self.datas.kontragent_id,
            sklad_id: self.datas.sklad_id,
            datetime: self.datas.created_at
          }
        }).then(function (response) {
          response.data.forEach(function (key, value) {
            if (key.pay_type_id == 3) {
              self.qarz_dollar = key.total;
            } else {
              self.qarz += key.total;
            }
          });
          self.print = true;
        });
      },
      Mysklad() {
        let self = this;
        axios({
          method: "get",
          url: "api/v1/sklads/id/" + self.datas.sklad_id
        }).then(function (response) {
          self.mysklad = response.data;
        });
      },
      Summa() {
        this.all_count = 0;
        this.all_price = 0;
        this.all_summa = 0;
        this.datas.rasxod_table.forEach(element => {
          this.all_count += element.count;
          this.all_price += element.price;
          this.all_summa += element.summa;
        });
      }
    }
  }
</script>
<style scoped>
  table {
    break-inside: auto;
  }

  tr {
    break-inside: avoid;
    break-after: auto;
  }

  thead {
    display: table-header-group;
  }

  tfoot {
    display: table-footer-group;
  }

  .prints td,
  th {
    border: 2px solid #000 !important;
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  #my-node {
    width: 21cm;
    min-height: 29.7cm;
    height: auto !important;
    padding: 0 10px;
    margin: 8px;
  }

  #my-node>div {
    /* height: 297bb; */
  }

  .header-style {
    border: 1px solid;
    border-radius: 12px;
    margin: 1rem auto;
  }

  .header-style>p {
    font-size: 14pt !important;
    line-height: 1.2em;
    margin: 0.4em auto;
    padding: 0 10px;
  }

  .font-point {
    font-size: 14pt !important;
    margin: 1rem auto;
  }
</style>
